import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { CFormLabel, CCol } from '@coreui/react';
import PropTypes from "prop-types";

const SearchableProductSelect = ({ products, value, onChange, label = "Select Product" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);
    console.log("Products in SearchableProductSelect:", products);
    const selectedProduct = products.find(p => p.id == value);
    const displayValue = selectedProduct?.loanType || '';

    const filteredProducts = useMemo(() => {
        const searchLower = String(searchTerm || '').toLowerCase().trim();
        if (!searchLower) return products;

        return products.filter(product => {
            const loanType = String(product.loanType || '').toLowerCase();
            return loanType.includes(searchLower);
        });
    }, [products, searchTerm]);

    const handleSelect = useCallback((productId) => {
        onChange(productId);
        setIsOpen(false);
        setSearchTerm('');
    }, [onChange]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm('');
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <CCol xs={6} className="pt-20" ref={dropdownRef}>
            <CFormLabel className="custom-form-label">
                {label} <span className="red-star"> *</span>
            </CFormLabel>

            <div className="position-relative">
                <div
                    className={`form-control custom-select custom-form-input ${!displayValue ? 'text-muted' : ''}`}
                    style={{ cursor: 'pointer', minHeight: '37px', background: "#e9ecef", borderRadius: "10px", border: "1px solid #000" }}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <div className="d-flex align-items-center h-100">
                        <span className="flex-grow-1 text-truncate ">
                            {displayValue || 'Select Product'}
                        </span>
                        <i
                            className={`fas fa-chevron-${isOpen ? 'up' : 'down'} ms-2`}
                            style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)' }}
                        />
                    </div>
                </div>

                {isOpen && (
                    <div
                        className="position-absolute w-100 border rounded shadow mt-1"
                        style={{
                            maxHeight: '300px',
                            overflowY: 'auto',
                            zIndex: 1050,
                            background: 'white'
                        }}
                    >
                        <div className="p-2 border-bottom bg-light">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Type to filter products..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                autoFocus
                            />
                        </div>

                        {filteredProducts.length === 0 ? (
                            <div className="p-3 text-center text-muted">
                                No products found
                            </div>
                        ) : (
                            filteredProducts?.filter(product => product.is_active === 1)?.slice(0, 50).map((product) => (
                                <div
                                    key={product.id}
                                    className={`p-3  border-bottom hover-bg-light ${product.id == value ? 'bg-primary text-white' : ''
                                        }`}
                                    style={{ lineHeight: '1.5', cursor: 'pointer' }}
                                    onClick={() => handleSelect(product.id)}
                                >
                                    <strong>{product.loanType?.toUpperCase()} - ₹ {product.price}</strong>
                                    {product.id == value && <i className="fas fa-check ms-2"></i>}
                                </div>
                            ))
                        )}
                    </div>
                )}
            </div>
        </CCol>
    );
};

SearchableProductSelect.propTypes = {
    products: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            loanType: PropTypes.string,
        })
    ).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
};

export default SearchableProductSelect;
